import { getAlgoliaQuery } from "../../helpers";
import { useIsClientSide } from "../isClient.hook";

const useAlgoliaQueryHook = () => {
    const isClient = useIsClientSide();
    return isClient && getAlgoliaQuery() ? `?q=${getAlgoliaQuery()}` : "";
};

export { useAlgoliaQueryHook };
